import { FormItem } from '@billy/design-system'
import { ReactElement, useId } from 'react'

import { ImportedInvoiceReviewCurrencySelect } from '../ImportedInvoiceReviewAmountField/elements/ImportedInvoiceReviewCurrencySelect'
import * as Styled from '../ImportedInvoiceReviewAmountField/styles'

interface ImportedInvoiceReviewGrossAmountFieldProps {
  currency: string | null
  grossAmount: number | null
  label: string
}

/**
 * The line's net plus VAT amount. Approve sends no gross amount — the server computes it from the
 * lines — so it is never a form value and can't be edited.
 */
export const ImportedInvoiceReviewGrossAmountField = ({
  currency,
  grossAmount,
  label,
}: ImportedInvoiceReviewGrossAmountFieldProps): ReactElement => {
  const currencySelectId = useId()

  return (
    <FormItem label={label}>
      {({ id }) => (
        <Styled.ImportedInvoiceReviewAmountFieldWrapper>
          <Styled.AmountInput disabled id={id} isFallbackToZero={false} value={grossAmount ?? undefined} />
          <ImportedInvoiceReviewCurrencySelect disabled id={currencySelectId} selectedId={currency ?? undefined} />
        </Styled.ImportedInvoiceReviewAmountFieldWrapper>
      )}
    </FormItem>
  )
}
